'use strict';

const { h } = require('phy');
const { Translate, WithI18n } = require('@grpn/preact-l10n');
const Header = require('../../shared/views/header');
const RedemptionProvider = require('../../redemption/views/redemption-provider');
const CouponsFilter = require('../../coupons/views/coupons-filter');
const CouponsList = require('../../coupons/views/coupons-list-filter');
const RichContent = require('../../coupons/views/rich-content');
const MerchantExpiredOffers = require('./merchant-offers-table');
const SidebarBrowseLetter = require('./sidebar-browse-letter');
const SidebarBrowseMerchant = require('./sidebar-browse-merchant');
const Carousel = require('../../shared/views/carousel');
const MerchantOfferCount = require('./merchant-offer-count');
const EmailSubscription = require('../../email_subscription/views/email-subscription');
const Breadcrumbs = require('../../../components/breadcrumbs');
const LeaderboardBannerWrapper = require('../../../components/leaderboard_banner');
const MerchantLogoImage = require('../../shared/views/merchants/merchant-logo-image');
const getUniqueArrayFromObjects = require('../../support/get-unique-array-from-objects');
const { pruneData } = require('../../support/prune-data');
const MerchantBoxHeading = require('./merchant-box-heading');

function getCarouselOptions(coupons) {
  return {
    className: 'carousel-sidebar',
    coupons,
    autoplay: true,
    navigation: false,
    options: {
      perPage: 1,
    },
  };
}

function MerchantMain({ payload, params, deps }) {
  const {
    navigationMerchants,
    merchantDetails,
    merchantMeta,
    couponsForList,
    topMerchantsList,
    similarMerchants,
    directRedemption,
    advertsForCarousel,
    leaderboardAdverts,
    referralSource,
  } = payload;

  const {
    routes,
    csrfToken,
    mainHeader,
    showUberOffer,
    breadcrumbList,
    isTouch,
    showLeaderboardBanner,
    showDisruptor,
  } = deps;

  const {
    merchantMedia,
    merchantName,
    merchantId,
    merchantWebsiteName,
    description,
  } = merchantDetails;

  const offerTypes = getUniqueArrayFromObjects(
    couponsForList,
    c => c.offerType
  );

  const leaderboardBanner = LeaderboardBannerWrapper({
    show: showLeaderboardBanner,
    adverts: leaderboardAdverts,
    isTouch,
    outerClassName: 'merchant-section',
    routes: pruneData(routes, 'merchant:show'),
  });

  const { serpsDetails } = merchantMeta;

  return h('article.merchant', [
    h(RedemptionProvider, { routes, directRedemption, referralSource }),
    h(Header, {
      routes,
      merchants: navigationMerchants,
      titleText: mainHeader,
      showTitleOntouch: false,
    }),
    h('section.container', [
      Breadcrumbs(breadcrumbList),
      h('.merchant-layout', [
        isTouch && h('h1.merchant-title', mainHeader),
        h(
          '.merchant-sidebar',
          {
            'data-bhw': 'MerchantSidebar',
          },
          [
            h('.merchant-section-logo', [
              h(WithI18n, {}, i18n =>
                h(
                  '.merchant-logo',
                  MerchantLogoImage({
                    className: 'merchant-logo-image',
                    data: merchantMedia,
                    size: ['w_138,h_138'],
                    sourceProperties: [{ media: 768, size: 'w_62,h_62' }],
                    lazyload: false,
                    alt: i18n.t('js.modules.shared.LogoAltTextFormat', {
                      0: merchantName,
                    }),
                  })
                )
              ),
              h(
                'a.merchant-outlink',
                {
                  href: routes.redirect.merchant.replace(
                    '{merchantId}',
                    merchantId
                  ),
                  target: '_blank',
                  rel: 'noopener nofollow',
                  'data-bhc': `direct-link:${params.merchantSlug}`,
                },
                merchantWebsiteName
              ),
              h('.merchant-statistics', [
                h('span.icon-tag'),
                h(
                  Translate,
                  {
                    0: couponsForList.length,
                  },
                  'modules.widget.Statistics.CodesAvailable'
                ),
              ]),
            ]),
            offerTypes.length > 1 &&
              h('fieldset.merchant-section', [
                h(
                  Translate,
                  {
                    tag: 'legend',
                    attrs: {
                      class: 'merchant-heading merchant-heading-filter',
                    },
                  },
                  'modules.shared.OfferFilter'
                ),
                CouponsFilter({ coupons: couponsForList }),
              ]),
          ]
        ),
        h('.merchant-content', [
          h(
            '.merchant-section',
            {
              'data-bhw': 'MerchantCouponsList',
            },
            h(CouponsList, {
              routes,
              coupons: couponsForList,
              media: 'callout',
              showUberOffer,
              referralSource,
              directRedemption,
              showDisruptor,
            })
          ),
          !isTouch && leaderboardBanner,
          h('.merchant-section', [
            MerchantBoxHeading(merchantName, serpsDetails),
            MerchantExpiredOffers({ offers: couponsForList }),
          ]),
          isTouch && leaderboardBanner,
        ]),
        h('.merchant-meta', [
          description &&
            h('.merchant-section', [
              h(
                Translate,
                {
                  tag: 'h2',
                  attrs: { class: 'merchant-heading' },
                  0: merchantName,
                },
                'modules.merchant.AboutMerchantHeadingFormat'
              ),
              h('span.merchant-text', description),
            ]),
          EmailSubscription({
            csrfToken,
            routes,
            classNames: {
              outer: 'merchant-section',
            },
            bhwName: `MerchantEmailSubscription:${params.merchantSlug}`,
          }),
          merchantMeta.didYouKnow &&
            h('.merchant-section', [
              h(
                Translate,
                {
                  tag: 'h3',
                  attrs: { class: 'merchant-heading' },
                  0: merchantName,
                },
                'modules.merchant.DidYouKnowHeadingFormat'
              ),
              merchantMeta.didYouKnow,
            ]),
          merchantMeta.sitePicks &&
            h('.merchant-section', [
              h(
                Translate,
                {
                  tag: 'h3',
                  attrs: { class: 'merchant-heading' },
                  0: merchantName,
                },
                'modules.merchant.SitePicksHeadingFormat'
              ),
              h('.merchant-text', {
                dangerouslySetInnerHTML: { __html: merchantMeta.sitePicks },
              }),
            ]),
          h('.merchant-section', [
            h(
              Translate,
              {
                tag: 'h3',
                attrs: { class: 'merchant-heading' },
              },
              'modules.merchant.OfferCountsTableHeading'
            ),
            h(MerchantOfferCount, { coupons: couponsForList }),
          ]),
          advertsForCarousel &&
            advertsForCarousel.length > 0 &&
            h(
              '.merchant-section.carousel-container',
              Carousel({ routes, ...getCarouselOptions(advertsForCarousel) })
            ),
          h('.merchant-section', h(SidebarBrowseLetter, { routes })),
          h(SidebarBrowseMerchant, {
            routes,
            className: '.merchant-section',
            merchants: topMerchantsList,
            localisation: {
              resource: 'modules.shared.TopBrands',
              data: { tag: 'h3', attrs: { class: 'sidebar-browse-title' } },
            },
            bloodhound: 'SideBarPopularStores',
          }),
          similarMerchants.length > 0 &&
            h(SidebarBrowseMerchant, {
              routes,
              className: '.merchant-section',
              merchants: similarMerchants,
              localisation: {
                resource: 'modules.merchant.SimilarBrandsFormat',
                data: {
                  tag: 'h3',
                  attrs: { class: 'merchant-heading' },
                  0: merchantName,
                },
              },
              bloodhound: 'SideBarRelatedBrands',
            }),
        ]),
        h('.merchant-seotext', [
          h(RichContent, { data: merchantMeta.richContent }),
        ]),
      ]),
    ]),
  ]);
}

module.exports = MerchantMain;
